import { useQuery } from '@tanstack/react-query';
import type { ApiException } from '@/lib/api/types';
import { fetchAiReview } from './aiReviewApi';
import type { AiReviewList } from './aiReviewTypes';

/**
 * "저점 신호 검토" 조회 훅. (2026-10-17 · BACKLOG I-94)
 *
 * 1분. 장중 감시가 몇 분마다 돌아 새 국면 · 줄이 생길 수 있지만, 화면이 그보다 자주 물어도 같은 값이다.
 * 🔴 저절로 갱신되지는 않는다 — refetchInterval 이 없어 화면에 다시 들어오거나 창에 포커스가 돌아올 때 새로 읽는다.
 */
const STALE_TIME = 60 * 1000;

/**
 * 기간 — 최근 30일 안에 연 국면 + 아직 열린 국면(서버 기본값과 같다).
 * 🔴 저점 신호 검토 화면과 스윙(6개월) 감시 표의 🔎 칩이 같은 값을 쓴다 — queryKey 가 같아야 요청이 한 번만 나가고 캐시를 나눠 쓴다(2026-10-18)
 */
export const AI_REVIEW_DAYS = 30;

/**
 * @param enabled false 면 부르지 않는다 — 스윙 탭 · 도움말이 SWING_A 일 때만 켠다(2026-10-18)
 */
export function useAiReview(days: number, enabled = true) {
  return useQuery<AiReviewList, ApiException>({
    queryKey: ['trading', 'ai-review', days],
    queryFn: () => fetchAiReview(days),
    staleTime: STALE_TIME,
    enabled,
  });
}
